import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
  PlainSelectionsReducer,
} from './common.js';

const HotspotSelectionsReducer = PlainSelectionsReducer;

const HotspotSelectionsAggregator = ({ responses }) =>
  (responses || []).reduce((acc, response) => {
    const { data } = response || {};
    const { answers } = data || {};

    if (!answers) return acc;

    (answers || []).forEach(({ id: shapeId }) => {
      if (!acc[shapeId]) {
        acc[shapeId] = { count: 0, value: shapeId };
      }

      acc[shapeId].count += 1;
    });

    return acc;
  }, {});

export default {
  AggregateMap: GlobalAggregateMap(HotspotSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(HotspotSelectionsReducer),
};
